import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';

const ExtraProductTitle = (props) => {
    const {
        availabilityLink,
        title,
        subtitle,
    } = props;

    return (
        <Col xs={12} className="text-center">
            <div className="page-title-wrapper">
                <h1>{title}</h1>
                {availabilityLink}
                {
                    subtitle
                    && (
                        <div className="available-states">
                            {subtitle}
                        </div>
                    )
                }
            </div>
        </Col>
    );
};

ExtraProductTitle.propTypes = {
    availabilityLink: PropTypes.node,
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
};

export default ExtraProductTitle;
